import { OfferListingStatus } from '@steelbuy/ts-shared';
import enLiterals from './literals-en';

const literals = structuredClone(enLiterals);
literals.application.account.tabOrganisation = 'Organization';
literals.application.accountAddAddress.previousPageTitle = 'Organization Account';
literals.application.accountEditAddress.previousPageTitle = 'Organization Account';
literals.application.accountEditAddressNotFound.previousPageTitle = 'Organization Account';
literals.application.accountEditPaymentTerms.previousPageTitle = 'Organization Account';
literals.application.checkout.submitCheckoutButtonLabel = 'Submit Purchase Request';
literals.application.checkout.negotiationExists =
    'Another member from your organization is currently engaged in negotiations for this item.';
literals.application.checkout.checkbox1Label =
    'By ticking this box, I represent that I am authorized to enter into this contract for and on behalf of {{organisationName}}.';
literals.application.checkoutSuccess.emailHint = 'You will receive an email with purchase confirmation.';
literals.application.checkoutSuccess.banner.headline = 'Need Assistance?';
literals.application.checkoutSuccess.banner.contactText = 'Our U.S. support team is available at:';
literals.application.checkoutSuccessDynamicDelivery.documentationIssuedHint =
    'You will receive automated confirmation including invoice and Material Test Reports (MTRs).';
literals.application.purchaseContactEdit.backLinkText = 'Organization Account';
literals.application.organisation.organisationCardHeader = 'Organization';
literals.application.userForm.errors.invalidDomain = 'Email must be from same domain as organization';
literals.application.myOrders.bannerBuy.description = [
    'Instant access to materials to maximize your time.',
    'The fastest way to buy steel, where technology does the work.',
    'Fully managed order process.',
];
literals.application.createBulkListing.fields.price = 'Price (per ton)';
literals.application.createBulkListing.fields.testCertificate = 'MTR (Mill Test Report)';
literals.application.createListingListUpload.packageTitlePlaceholder = 'e.g. 20 coils, galvanized, hot rolled..';
literals.application.createBulkListing.editListingModal.uploadTestCertificate = 'Upload MTR (Mill Test Report)';
literals.application.createBulkListing.editListingModal.testCertToFollow = 'MTR (Mill Test Report) to follow';
literals.application.legalCheckboxes.checkbox1Label =
    'By ticking this box, I represent that I am authorized to enter into this contract for and on behalf of {{organisationName}}.';
literals.application.listingDetails.testCertificateTitle = 'MTR (Mill Test Report)';
literals.application.materialStep.anonymityBannerText = 'Your MTR (Mill Test Report) will be anonymized by SteelBuy.';
literals.application.myOffers.infoMsg =
    'The seller can review the proposed price and decides to accept, reject, or counter the offer. If no action is taken before the date and time, the negotiation will be canceled automatically.';
literals.application.manageOffers.infoMsg =
    'The buyer can review the proposed price and decides to accept, reject, or counter the offer. If no action is taken before the date and time, the negotiation will be canceled automatically.';
literals.application.offerListingsFilter.optionLabels[OfferListingStatus.CANCELLED] = 'Canceled';
literals.application.offers.notificationMsgBuyer =
    'The seller can review the proposed price and decides to accept, reject, or counter the offer. If no action is taken before the date and time, the negotiation will be canceled automatically.';
literals.application.offers.notificationMsgSeller =
    'The buyer can review the proposed price and decides to accept, reject, or counter the offer. If no action is taken before the date and time, the negotiation will be canceled automatically.';
literals.application.manageOffers.pageHeader = 'Listing Offers';
literals.application.navigation.itemLabels.manageOffers = 'Listing Offers';
literals.application.listingDetails.deliveryTitle = 'Delivery Details';
literals.constants.primaryAddress.line1 = '22355 West Eleven Mile Road';
literals.constants.primaryAddress.line2 = '';
literals.constants.primaryAddress.line3 = '';
literals.constants.primaryAddress.line4 = '';
literals.constants.primaryAddress.line5 = '';
literals.constants.primaryAddress.postcode = 'Southfield, MI 48033';
literals.constants.primaryAddress.country = 'USA';
literals.constants.companyName = 'SteelBuy USA';
literals.constants.emailSupport = 'sales@steelbuyusa.com';
literals.constants.emailInfo = 'sales@steelbuyusa.com';
literals.constants.customerServicePhone = '';
literals.constants.taxNumber = 'Federal Tax ID (EIN): 38-0445860';
literals.constants.copyright = 'Copyright SteelBuy USA. 2026';
literals.constants.companyRegistrationNumber = '';

export default literals;
